
import filters from '@/filters';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';

import ModalReport from '@/components/report/ModalReport.vue';
import ModalCompleteReport from '@/components/report/ModalCompleteReport.vue';

@Component({
  components: {
    ModalReport,
    ModalCompleteReport,
  },
  filters,
})
export default class AdvertisingDetail extends Vue {

  /* VUEX */

  // ACTION
  @Action('actionSelectAdvertisementById', { namespace: 'advertisement' })
  private actionSelectAdvertisementById: any;
  @Action('actionReportAdvertisement', { namespace: 'advertisement' })
  private actionReportAdvertisement: any;

  // STATE
  @State('advertisement', { namespace: 'advertisement' })
  private advertisement: any;

  /* INITIALIZATION */

  private isShowReport: boolean = false;
  private isShowCompleteReport: boolean = false;
  private breadcumbs:any[] = [
    {
      text: "page_advertising",
      href: "ads"
    }
  ]

  private tabList = ['active','inactive']

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.actionSelectAdvertisementById(this.$route.params.id);
    this.breadcumbs.push({
      text: `page_ads${this.$route.params.type}`,
      href: "#"
    })
  }

  /* LISTENER */

  private listenerReport() {
    this.isShowReport = false;
    this.isShowCompleteReport = true;
    this.actionSelectAdvertisementById(this.$route.params.id);
  }

  /* METHOD */

  private reportedAction(report_reason: string) {
    this.advertisement.report_reason = report_reason;
    this.actionReportAdvertisement({listener: this.listenerReport});
  }
}
